import {
  UserDailySail,
  DailySail,
  IActiveDailySailResponse
} from "store/apis/personalDailyDealsAPI/personal-daily-deals.types"
import { TAGS, api } from "../../api"

export const personalDailyDealsApi = api.enhanceEndpoints({
  addTagTypes: [TAGS.PERSONAL_DAILY_DEALS]
})

export const personalDailyDealsEndpoints =
  personalDailyDealsApi.injectEndpoints({
    endpoints: (builder) => ({
      getList: builder.query<DailySail[], void>({
        query: () => ({
          url: "/personal-daily-sails",
          method: "GET"
        }),
        providesTags: [{ type: TAGS.PERSONAL_DAILY_DEALS, id: "LIST" }]
      }),
      getActiveDeals: builder.query<UserDailySail | null, void>({
        query: () => ({
          url: "/personal-daily-sails/me/active",
          method: "GET"
        }),
        transformResponse: (response: IActiveDailySailResponse) =>
          response.activeDeal,
        providesTags: [
          { type: TAGS.PERSONAL_DAILY_DEALS, id: "MY_ACTIVE_DEAL" }
        ]
      }),
      spinWheal: builder.mutation<UserDailySail, void>({
        query: () => ({
          url: "/personal-daily-sails/spin",
          method: "PATCH"
        }),
        async onQueryStarted(_, { dispatch, queryFulfilled }) {
          try {
            const { data } = await queryFulfilled
            // updateQueryData (not upsertQueryData): /spin returns the already
            // unwrapped deal; upsert would re-run getActiveDeals' transformResponse
            // and collapse it to undefined
            dispatch(
              personalDailyDealsEndpoints.util.updateQueryData(
                "getActiveDeals",
                undefined,
                () => data
              )
            )
          } catch {
            //catch
          }
        }
      })
    })
  })
